import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";

const Pill = ({ s }) => {
  const map = {
    not_submitted: "border-line text-sub",
    submitted: "border-warn text-warn",
    cleared: "border-success text-success",
    flagged: "border-warn text-warn",
    blocked: "border-danger text-danger",
  };
  return <span className={`text-[10px] font-mono uppercase border px-2 py-0.5 ${map[s] || "border-line text-sub"}`}>{s || "not_submitted"}</span>;
};

export default function AdminCompliance() {
  const [users, setUsers] = useState([]);
  const nav = useNavigate();
  const load = useCallback(() => {
    api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  const buyers = users.filter((u) => u.role !== "admin");

  return (
    <DashboardLayout testid="admin-compliance-page">
      <div className="p-8 md:p-12 max-w-7xl">
        <div className="overline">Administration — Compliance & Sanctions</div>
        <h1 className="h-serif text-5xl text-ink mt-3">KYC review queue</h1>
        <p className="text-sub mt-3 max-w-2xl text-sm leading-relaxed">
          Every approved buyer must submit a compliance profile before submitting deals.
          Review the profile, run an OFAC SDN check against the legal entity + beneficial
          owners, then clear, flag, or block the account.
        </p>

        <div className="mt-8 border border-line bg-parchment">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-line text-left font-mono text-xs text-sub uppercase tracking-wider">
                <th className="p-4">Account</th>
                <th className="p-4">Legal entity</th>
                <th className="p-4">KYC status</th>
                <th className="p-4">OFAC check</th>
                <th className="p-4 text-right">Review</th>
              </tr>
            </thead>
            <tbody data-testid="compliance-table">
              {buyers.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-sub">No buyer accounts yet.</td></tr>}
              {buyers.map((u) => {
                const c = u.compliance || {};
                return (
                  <tr key={u.user_id} className="border-b border-line last:border-0">
                    <td className="p-4">
                      <div className="text-ink">{u.name}</div>
                      <div className="text-xs text-sub">{u.email}</div>
                      <div className="text-xs text-sub">{u.company || "—"}</div>
                    </td>
                    <td className="p-4">
                      <div className="text-sub text-sm">{c.legal_entity_name || "—"}</div>
                      <div className="text-xs text-sub">{c.jurisdiction || ""}</div>
                    </td>
                    <td className="p-4"><Pill s={c.kyc_status} /></td>
                    <td className="p-4">
                      {c.ofac_check
                        ? <div>
                            <Pill s={c.ofac_check.result} />
                            <div className="text-[10px] font-mono text-sub mt-1">
                              {c.ofac_check.checked_by}<br />{c.ofac_check.checked_at?.slice(0, 10)}
                            </div>
                          </div>
                        : <span className="text-xs text-sub italic">not run</span>}
                    </td>
                    <td className="p-4 text-right">
                      <button onClick={() => nav(`/admin/compliance/${u.user_id}`)}
                              className="link text-xs" data-testid={`review-${u.user_id}`}>
                        Review →
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
